/* @flow */
import * as React from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';

// Styles
import styles from './BraindateParticipantsTable.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

// Utils
import messages from 'src/shared/app/braindate/l10n/braindateL10n';
import { getUserId } from '@braindate/domain/lib/user/util';

// Components
import Modal from 'src/shared/app/base/modal/component/Modal';
import BraindateParticipantsTableRow from 'src/shared/app/braindate/component/participantList/BraindateParticipantsTableRow';

// Types
import type { BraindateParticipantListElement } from './BraindateParticipants';
import type { User } from '@braindate/domain/lib/user/type';

type Props = {
  participants: User[],
  columns: BraindateParticipantListElement[],
  onClose: () => void,
};

const useStyles = createUseThemeStyles(styles);

const BraindateParticipantsTable = ({
  participants,
  columns,
  onClose,
}: Props) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <Modal
      width="80vw"
      title={intl.formatMessage(messages.participantsListCount, {
        count: participants.length,
      })}
      content={
        <div className={classes.tableContainer}>
          <table className={classes.table}>
            <thead>
              <tr>
                {columns.map(({ center, title }, key) => (
                  <td
                    key={key}
                    className={classNames(classes.tableHeadCell, {
                      [classes.tableCellCentered]: center,
                    })}
                  >
                    {title}
                  </td>
                ))}
              </tr>
            </thead>

            <tbody className={classes.tableBody}>
              {participants.map((participant) => (
                <tr key={`participant-${getUserId(participant)}`}>
                  <BraindateParticipantsTableRow
                    onClose={onClose}
                    participant={participant}
                    columns={columns}
                  />
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      }
      hideActions
      showClose
      handleClose={onClose}
    />
  );
};

export default React.memo<Props>(BraindateParticipantsTable);
